/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function() {
	/**
	 * @interface ToolbarAPI
	 * @hideconstructor
	 * @classdesc The interface for Content Toolbar feature. It provides ways of managing the ODT of a content.
	 */
	class ToolbarAPI{
		/**
		 * @function ToolbarAPI#refresh
		 * @description update the on-demand toolbar for a content
		 */
		refresh(){}
	}
	return ToolbarAPI;
});